import { useSelector } from 'react-redux';
import { RootState } from 'store/types';

export const useOrganization = () => {
  const navCommunity = useSelector(
    (state: RootState) => state.auth.navCommunity,
  );
  return navCommunity;
};
